import { IActionContext } from '../helpers/ActionContext';
import { CommonErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IDataAlertInfo } from '../models/IDataAlertInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataAlerts } from '../resources/DataAlerts';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { IErrorDetail } from './ContentActionNotification';
import { ServerService } from './ServerService';

export class RemoveSelfFromAlertsAction {

  public static $inject = [
    'ActionHelpers',
    'ConfirmActionDialog',
    'DataAlerts',
    '$translate',
    'ServerService'
  ];

  constructor(
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private DataAlerts: DataAlerts,
    private $translate: ng.translate.ITranslateService,
    private ServerService: ServerService) { }

  public removeSelf(alerts: Set<IDataAlertInfo>, context: IActionContext): ng.IPromise<IResult> {

    const self = this.ServerService.sessionUserId();

    let dialogBodyText: string;
    if (alerts.size() === 1) {
      dialogBodyText = this.$translate.instant('confirmRemoveSelfFromAlert', {
        ALERT_NAME: L10n.elideIfLong(alerts.first().name)
      });
    } else {
      dialogBodyText = this.$translate.instant('confirmRemoveSelfFromAlerts', {
        ALERT_COUNT: alerts.size()
      }, L10n.Interpolations.Count);
    }

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('confirmRemoveSelfFromAlertTitle'),
      isDeleteAction: true,
      bodyText: dialogBodyText,
      actionName: this.$translate.instant('confirmRemoveSelfButton'),
      action: () => this.DataAlerts.removeUsers({ dataAlertIds: alerts.keys(), userIds: [self] })
        .then(result => this.notifyResult(alerts, result))
    }).result;
  }

  private notifyResult(alerts: Set<IDataAlertInfo>, result: IResult) {
    this.ActionHelpers.notifyStandardError(
      alerts,
      {
        successId: 'removeSelfFromDataAlertsSuccess',
        errorId: 'removeSelfFromDataAlertsError'
      },
      (errorItem: IErrorItem<IDataAlertInfo>) => this.errorDetailFor(errorItem)
    )(result);
  }

  private errorDetailFor(errorItem: IErrorItem<IDataAlertInfo>): IErrorDetail {
    const itemName = errorItem.item.name;
    let errorMessage: string;

    switch (errorItem.error.code) {
      case CommonErrorCode.DataAlertNotFound:
        errorMessage = this.$translate.instant('errorDataAlertNotFound', { ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      case CommonErrorCode.CallingUserInsufficientPermissions:
        errorMessage = this.$translate.instant('errorDataAlertNoPermission', { ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      case CommonErrorCode.DataAlertRecipientNotFound:
        errorMessage = this.$translate.instant('errorDataAlertNotRecipient', { ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      default:
        errorMessage = this.$translate.instant('errorUnknown');
    }

    return { itemName, errorMessage };
  }

}

Module.instance().service('RemoveSelfFromAlertsAction', RemoveSelfFromAlertsAction);
